const HealthBarStates = {
  tasksUnknown: {
    className: "unknown",
    label: "Unknown"
  },
  tasksHealthy: {
    className: "healthy",
    label: "Healthy"
  },
  tasksOverCapacity: {
    className: "over-capacity",
    label: "Over Capacity"
  },
  tasksUnhealthy: {
    className: "unhealthy",
    label: "Unhealthy"
  },
  tasksStaged: {
    className: "staged",
    label: "Staged"
  }
};

module.exports = HealthBarStates;



// WEBPACK FOOTER //
// ./plugins/services/src/js/constants/HealthBarStates.js